module.exports = __webpack_public_path__ + "static/cqc-clinics-fcd7e9aeee93c52c29d125a147731ae4.png";